<template>
  <div class="info">
    <lb-table
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '提现时间', prop: 'createdTime', minWidth: '120' },
        { label: '提现类型', prop: 'typeLabel', minWidth: '220' },
        { label: '提现方式', prop: 'payType', minWidth: '120' },
        { label: '提现账号', prop: 'account', minWidth: '120' },
        { label: '提现金额', prop: 'applyMoney', minWidth: '120' },
        { label: '手续费', prop: 'handlingFee', minWidth: '120' },
        { label: '实际到账', prop: 'receivedMoney', minWidth: '120' },
        { label: '状态', prop: 'applyStatusLabel', minWidth: '120' }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: true
    }
  },
  watch: {
    id (val, vall) {
      this.id = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        userId: this.id,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.getWithdrawlPageList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

